<template>
  <div>
    <kt-datatable ref="datatable" v-bind="datatableProps"></kt-datatable>
  </div>
</template>

<script>
import { ApiUrl } from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";
import manageColumns from '../datatable/columnsWithManageAccess';
import actionsColumnWithManageAccess from '../components/actionsColumnWithManageAccess'

export default {
  name: 'money-request-with-manage',
  props: {
    query: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      datatableProps: {
        id: 'datatableWithManageAccess',
        data: {
          type: 'remote',
          source: {
            read: {
              url: ApiUrl.path('admin/money-request/fetch'),
              method: 'GET',
              headers: AuthorizationHeader,
              map: function (res) {
                return res.data.data;
              },
              params: {
                query: this.query,
              },
            },
          },
          pageSize: 10,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
        },
        layout: {},
        pagination: false,
        sortable: true,
        columns: manageColumns,
        actions: actionsColumnWithManageAccess,
      },
    };
  },
  methods: {
    reload() {
      if (this.$refs.datatable && this.$refs.datatable.KTDatatable) {
        this.$refs.datatable.reload();
      }
    },
  },
};
</script>
